import React, { FC } from "react"
import Image, { FluidObject } from "gatsby-image"
//mui
import { makeStyles, Typography } from "@material-ui/core"

interface props {
  title: string
  image?: {
    fluid: FluidObject
  }
  textType?: "long" | "short"
}
const LandingSection: FC<props> = ({ title, image, textType = "short" }) => {
  const useStyle = makeStyles(theme => ({
    root: {
      width: "100%",
      height: "410px",

      position: "relative",
    },
    blogsImage: {
      width: "100%",
      height: "100%",
      position: "absolute",
      zIndex: -2,
    },
    overlay: {
      height: "100%",
      width: "100%",
      position: "absolute",
      opacity: "0.8",
      zIndex: -1,
    },
    contentWrapper: {
      height: "100%",
      width: "100%",
      maxWidth: "1280px",
      margin: "0 auto",
      color: "white",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1,
    },
    content: {
      fontWeight: 600,
      fontSize: textType === "short" ? "40px" : "30px",
      padding: "0 20px",
    },
  }))

  const classes = useStyle()
  return (
    <div className={classes.root}>
      <div className={`mainGradient ${classes.overlay}`}></div>
      <div className={classes.blogsImage}>
        <Image
          className={classes.blogsImage}
          fluid={image.fluid}
          alt="blogs"
        ></Image>
      </div>
      <div className={`${classes.contentWrapper}`}>
        <Typography className={classes.content}> {title} </Typography>
      </div>
    </div>
  )
}

export default LandingSection
